export const LOCATION_ADDRESS_KEYS = [
  'street',
  'number',
  'interiorNumber',
  'city',
  'state',
  'country',
  'postalCode',
];
